import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  MapAreaDevicesApiRequestBody,
  MapAreaDevicesApiResponse
} from 'src/app/pages/administration/report-groups/report-groups.types';

@Injectable({ providedIn: 'root' })
export class MapReportGroupService {
  readonly #http = inject(HttpClient);

  getMapAreaDevicesFromEvents(payload: MapAreaDevicesApiRequestBody): Observable<MapAreaDevicesApiResponse> {
    return this.#http.post<MapAreaDevicesApiResponse>('/api/map/area/devices-from-events', payload);
  }

  getMapAreaDevices(payload: MapAreaDevicesApiRequestBody): Observable<MapAreaDevicesApiResponse> {
    return this.#http.post<MapAreaDevicesApiResponse>('/api/map/area/devices', payload);
  }
}
